import { SearchBar } from '@ui/common/search-bar.tsx';

export const SearchLocation = ({
  onSearch,
}: {
  onSearch: (query: string) => void;
}) => {
  return (
    <div className="py-4">
      <SearchBar isEditable onChange={onSearch} />
    </div>
  );
};
